import { Component } from 'react';
import React from 'react';
import { connect } from 'react-redux';
import * as RefData from './refData'

class ViewCenso extends Component {
  state = {
    data: {
      ...this.props.censoData,
      networks: this.props.censoData.refSocialNetworks.map(n => n.id),
      banks: this.props.censoData.refBanks.map(b => b.id),
    },
    editable: this.props.session.user.permitions.map(p => p.rol).includes('ADMIN')
  }

  updateData(key, value) {
    if (!this.state.editable) return
    this.setState({
      data: {
        ...this.state.data,
        [key]: value
      }
    })
  }

  textInput(props) {
    const data = this.state.data
    return (
      <div className='line line-33'>
        <label>{props.label}</label>
        <div className="div-input-form">
          <input
            type={props.type ?? 'text'}
            value={data[props.key]}
            disabled={!this.state.editable}
            onChange={(e) => this.updateData(props.key, e.target.value)}
          />
        </div>
      </div>
    )
  }

  selectInput(props) {
    const data = this.state.data
    return (
      <div className='line line-33'>
        <label>{props.label}</label>
        <div className="div-input-form">
          <select defaultValue={0} value={data[props.key]} disabled={!this.state.editable} onChange={(e) => this.updateData(props.key, e.target.value)} >
            <option value={0} disabled={true}>--</option>
            {
              props.keyRef.map(r => <option value={r.id} key={r.id}>{r.name}</option>)
            }
          </select>
        </div>
      </div>
    )
  }

  switchInput(props) {
    const data = this.state.data
    return (
      <div className='line line-33'>
        <label >{props.label}</label>
        <div className='flex-center'>
          {
            data[props.key] ?
              <span onClick={() => this.updateData(props.key, false)} className='far fa-check-square primary-color' style={{ fontSize: '27px' }}></span>
              : <span onClick={() => this.updateData(props.key, true)} className='far fa-square' style={{ fontSize: '27px', color: 'rgba(0,0,0,0.6' }}></span>
          }
        </div>
      </div>
    )
  }

  checkInput(props) {
    const data = this.state.data
    console.log(props)
    return (
      <div className='line line-100'>
        <label >{props.label}</label>
        <div className=''>
          {
            props.keyRef.map(k =>
              <div className='line line-33' style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'space-evenly' }} key={k.id}>
                <label >
                  {k.name}
                </label>
                {
                  data[props.key].includes(k.id) ?
                    <span onClick={() => this.updateData(props.key, data[props.key].filter(f => f !== k.id))} className='far fa-check-square primary-color' style={{ fontSize: '27px' }}></span>
                    : <span onClick={() => this.updateData(props.key, [...data[props.key], k.id])} className='far fa-square' style={{ fontSize: '27px', color: 'rgba(0,0,0,0.6' }}></span>
                }
              </div>
            )
          }
        </div>
      </div >
    )
  }

  render() {
    const { censoData, ...data } = this.props
    return (
      <>
        <div style={{ minHeight: '205px' }}>
          <div className='modal-title-header'>
            <div className='title-modal-kml-input no-select'>Censo Galería</div>
            <div className='add-button'><i className="fas fa-times on-mouse-hover" onClick={data.close}></i></div>
          </div>
          <div className="points-content data-qr">
            <div className='request-image-list div-input-form' style={{ maxWidth: '870px' }}>
              {
                censoData.citizenFiles.map(i =>
                  <img key={`i-${i.id}`} src={i.url} alt={i.name} />
                )
              }
            </div>
            <p><span>Censó: </span>{`${censoData.user.nombres ?? ''} ${censoData.user.apellidos ?? ''}`}</p>
            {censoData.now && <p><span>Fecha: </span>{censoData.now.split('T')[0]}</p>}

            <div className="content-line">
              {this.textInput({ key: 'name', label: 'Nombre' })}
              {this.textInput({ key: 'lastName1', label: 'Primer Apellido' })}
              {this.textInput({ key: 'lastName2', label: 'Segundo Apellido' })}
              {this.textInput({ key: 'docNumber', label: 'Documento' })}
              {this.selectInput({ key: 'refGeneroId', label: 'Género', keyRef: RefData.gender })}
              {this.textInput({ key: 'edge', label: 'Edad', type: 'number' })}
              {this.textInput({ key: 'phone', label: 'Teléfono' })}
              {this.textInput({ key: 'email', label: 'Correo electrónico' })}
              {this.selectInput({ key: 'refCountryId', label: 'Nacionalidad', keyRef: RefData.countries })}
            </div>
            <h2 className='primary-color'>Vivienda</h2>
            <div className="content-line">
              {this.textInput({ key: 'homeNeighbor', label: 'Barrio' })}
              {this.textInput({ key: 'homeAddress', label: 'Dirección' })}
            </div>
            <h2 className='primary-color'>Espacio Físico</h2>
            <div className="content-line">
              {this.selectInput({ key: 'refGaleryType', label: '¿Dónde está ubicado el puesto?', keyRef: RefData.galeryType })}
              {this.textInput({ key: 'shopNumber', label: 'Número de puesto' })}
              {this.selectInput({ key: 'refGaleryTypeId', label: '¿La persona es adjudicada al puesto?', keyRef: RefData.awardedTypes })}
              {this.textInput({ key: 'time', label: '¿Hace cuánto se está ubicado?' })}
              {this.selectInput({ key: 'refUnidadTiempoId', label: 'Unidad de tiempo', keyRef: RefData.timeUnit })}
            </div>
            <h2 className='primary-color'>Actividad comercial</h2>
            <div className="content-line">
              {this.selectInput({ key: 'refActivityId', label: '¿Actividad comercial?', keyRef: RefData.activityType })}
              {this.textInput({ key: 'contribution', label: 'Valor contribución' })}
              {this.selectInput({ key: 'refFrecuencyContributionId', label: 'Frecuencia de la contribución', keyRef: RefData.frecContrb })}
              {this.checkInput({ key: 'networks', label: 'Redes sociales', keyRef: RefData.networks })}
              {this.checkInput({ key: 'banks', label: 'Cuentas bancarias', keyRef: RefData.banks })}
            </div>

            <div className='line line-100' style={{ display: 'flex', justifyContent: 'flex-end' }}>
              <div className="button-secondary line line-20 text-center">
                <div className="div-input-button">
                  <input type="button" value="Cerrar" onClick={data.close} />
                </div>
              </div>
              {
                this.props.session.user.permitions.map(p => p.rol).includes('ADMIN') &&
                <div className="button-primary line line-20 text-center">
                  <div className="div-input-button" style={{ backgroundColor: 'var(--primary-color)' }}>
                    <input
                      type="button" value="Guardar"
                      style={{ backgroundColor: 'var(--primary-color)', color: 'white' }}
                      onClick={() => this.props.onSave(this.state.data)}
                    />
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
      </>
    )
  }
}

function mapStateToProps(state) {
  return {
    session: state.session
  }
}

export default connect(mapStateToProps)(ViewCenso);